import type { FunctionComponent } from 'react';
import type { TypeOrderTableLineItemProps } from './types';

/**
 * OrderTableLineItem
 */
export const OrderTableLineItem: FunctionComponent<
  TypeOrderTableLineItemProps
> = ({ className = '', children }: TypeOrderTableLineItemProps) => (
  <td className={`p-4 align-middle ${className}`}>{children}</td>
);
